import { Loader2 } from "lucide-react";

type LoadingViewProps = {
  backgroundColor?: string;
};

export default function LoadingView({
  backgroundColor = "#ffffff",
}: LoadingViewProps) {
  return (
    <div
      className={`flex h-screen flex-1 items-center justify-center bg-[${backgroundColor}]`}
    >
      <Loader2 className="stroke-1.5 h-10 w-10 animate-spin text-gray-400" />
    </div>
  );
}
